import { JsonViewer } from '@textea/json-viewer';

export function ToastMessage({ message, errorData }: { message: string; errorData: unknown }) {
  return (
    <div>
      {message}
      <JsonViewer value={errorData} />
    </div>
  );
}
